
// danh mục group Store
export const Action_GetDMStore = "Action_GetDMStore";
export const Action_GetDMStoreSuccess = "Action_GetDMStoreSuccess";
// danh mục group category
export const Action_GetDMCategories = "Action_GetDMCategories";
export const Action_GetDMCategoriesSuccess = "Action_GetDMCategoriesSuccess";
// danh mục group category
export const Action_GetDMCategories1 = "Action_GetDMCategories1";
export const Action_GetDMCategoriesSuccess1 = "Action_GetDMCategoriesSuccess1";


export const Action_GetDMCategoriesBaoGia = "Action_GetDMCategoriesBaoGia";
export const Action_GetDMCategoriesBaoGiaSuccess = "Action_GetDMCategoriesBaoGiaSuccess";
// danh mục group Customers
export const Action_GetDMGroupCustomers = "Action_GetDMGroupCustomers";
export const Action_GetDMGroupCustomersSuccess = "Action_GetDMGroupCustomersSuccess";

// danh mục Banks
export const Action_GetDMBank = "Action_GetDMBank";
export const Action_GetDMBankSuccess = "Action_GetDMBankSuccess";
// danh mục group Config
export const Action_GetConfigByKey = "Action_GetConfigByKey";
export const Action_GetConfigByKeySuccess = "Action_GetConfigByKeySuccess";

export const Action_GetConfigAllSTKey = "Action_GetConfigAllSTKey";
export const Action_GetConfigAllSTKeySuccess = "Action_GetConfigAllSTKeySuccess";

export const Action_GetThongTinFormIn = "Action_GetThongTinFormIn";
export const Action_GetThongTinFormInSuccess = "Action_GetThongTinFormInSuccess";